import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Input from "./common/input";
import Pagination from "./common/pagination";
import Subscribe from "./ParameterSubscribe";
import Table from "./ParametersTable";
import { paginate } from "../utils/paginate";
import http from "../services/http";
import UserContext from "../context/userContext";
import { useEffect } from "react";
import Loading from "./common/loading";
import Checkbox from "./common/checkbox";

const Parameters = () => {
  const [user] = useContext(UserContext);
  const [searchQuery, setSearchQuery] = useState("");
  const [searching, setSearching] = useState(false);
  const [hideNIU, setHideNIU] = useState(true);
  const [parameters, setParameters] = useState([]);
  const [recentParameters, setRecentParameters] = useState([]);
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [subscription, setSubscription] = useState({
    code: "",
    site: "",
    type: "",
    email: false,
    push: false,
  });
  const [subscriptionInfo, setSubscriptionInfo] = useState({});
  const [page, setPage] = useState(1);
  const pageSize = 12;
  const navigation = '';
  
  useEffect(() => {
    async function getRecentParameters() {
      try {
        const { data } = await http.get(`/parameters/recent`);
        setRecentParameters(data);
      }
      catch {
        //ignore error
      }
    }
    
    if (user) {
      getRecentParameters();
    }
  }, [user]);

  const handleSearch = async (e) => {
    e.preventDefault();
    // Validate
    if (!searchQuery) return;

    try {
      setSearching(true);
      const { data } = await http.get(`/parameters?search=${searchQuery}`);
      setParameters(data);
      setPage(1);
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    setSearching(false);
  };

  const handleSubscribe = (parameter) => {
    setSubscription({
      code: parameter.CODE,
      type: "",
      site: user.SITE,
      email: false,
      push: false,
    });
    setSubscriptionInfo(parameter);
    setShowSubscribe(true);
  };

  const handleSubscriptionChange = ({ currentTarget: input }) => {
    const newData = { ...subscription };
    const value = input.type === "checkbox" ? input.checked : input.value;
    newData[input.name] = value;
    setSubscription(newData);
  };

  let filtered = [...parameters];
  if (hideNIU) filtered = parameters.filter((p) => p.IN_USE);

  const displayParameters = paginate(filtered, page, pageSize);
  const parameterCount = filtered.length;

  return (
    <React.Fragment>
      <div className="col mt-4">
        <div className="container">
          <div className="row mb-3">
            <div className="col">
              <Link to="/parameters/new">
                <button className="btn btn-primary">New</button>
              </Link>
            </div>
          </div>
          <form className="row">
            <div className="col-auto pt-2">
              <Checkbox
                name="inUse"
                label="In Use Only"
                checked={hideNIU}
                onClick={() => setHideNIU(!hideNIU)}
              />
            </div>
            <div className="col">
              <Input
                name="search-parameters"
                placeholder="Parameter Code"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.currentTarget.value)}
              />
            </div>
            <div className="col-auto">
              <button className="btn btn-primary" onClick={handleSearch}>
                Search
              </button>
            </div>
          </form>
        </div>
        <div className="row" style={{ minHeight: "400px" }}>
          {searching ? (
            <Loading />
          ) : (
            <div className="col">
              <Table
                data={displayParameters}
                total={parameterCount}
                handleSubscribe={handleSubscribe}
              />
              <Pagination
                itemsCount={parameterCount}
                pageSize={pageSize}
                currentPage={page}
                onPageChange={(p) => setPage(p)}
                navigation={navigation}
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col">
            <h3>Recently Updated</h3>
            <Table
              data={recentParameters}
              total={recentParameters.length}
              handleSubscribe={handleSubscribe}
            />
          </div>
        </div>
      </div>
      <Subscribe
        show={showSubscribe}
        data={subscription}
        info={subscriptionInfo}
        handleChange={handleSubscriptionChange}
        handleHide={() => setShowSubscribe(false)}
      />
    </React.Fragment>
  );
};

export default Parameters;
